import { breakpoints, Heading, Inline, Stack, Text, textVariants } from '@etg/wings';
import { BrandLogo } from '@eti/components';
import { useSiteContext, useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { constants } from '@eti/utils';
import { useMediaQuery } from 'usehooks-ts';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const headingBrandStyles = css`
  justify-content: space-between;
`;
const brandLogoStyles = css`
  height: 25px;
`;
const brandLogoMobileStyles = css`
  flex-shrink: 0;
  height: 14px;
`;
const texts = {
  etgFaresTitle: 'Product.ETG.Fares.Title',
  etgFaresTitleZeroPercentage: 'Product.ETG.Fares.Title.DiscountZeroPercentage',
  numberOfAvailableOption: 'Product.ETG.Fares.Number.Available.Option.Text',
  discountPercentageTitle: 'Product.ETG.Fares.DiscountPercentage.Title',
  discountZeroPercentageTitle: 'Product.ETG.Fares.SubTitle.DiscountZeroPercentage'
};
const EtgFaresHeading = ({
  discountPercentage,
  hasDiscount,
  numberOfSellableOptions,
  savedAmount
}) => {
  const {
    t
  } = useTranslation();
  const {
    brand
  } = useSiteContext();
  const {
    FLIGHTNETWORK
  } = constants.brands;
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints._768})`);
  const etgFaresTitle = hasDiscount ? t(texts.etgFaresTitle, discountPercentage) : t(texts.etgFaresTitleZeroPercentage);
  const discountPercentageTitle = hasDiscount ? t(texts.discountPercentageTitle, savedAmount) : t(texts.discountZeroPercentageTitle);
  return /*#__PURE__*/_jsxs(Stack, {
    spacing: 8,
    children: [isDesktop ? /*#__PURE__*/_jsxs(Inline, {
      alignY: "center",
      className: headingBrandStyles,
      spacing: 4,
      children: [/*#__PURE__*/_jsx(Heading, {
        level: 2,
        children: etgFaresTitle
      }), /*#__PURE__*/_jsxs(Stack, {
        align: "end",
        spacing: 4,
        children: [/*#__PURE__*/_jsx(BrandLogo, {
          brand: brand.code,
          className: brandLogoStyles,
          shouldUseContrast: brand.code === FLIGHTNETWORK
        }), /*#__PURE__*/_jsx(Text, {
          children: t(texts.numberOfAvailableOption, numberOfSellableOptions)
        })]
      })]
    }) : /*#__PURE__*/_jsxs(Stack, {
      spacing: 8,
      children: [/*#__PURE__*/_jsxs(Inline, {
        className: headingBrandStyles,
        noWrap: true,
        spacing: 8,
        children: [/*#__PURE__*/_jsx(Heading, {
          level: 2,
          children: etgFaresTitle
        }), /*#__PURE__*/_jsx(BrandLogo, {
          brand: brand.code,
          className: brandLogoMobileStyles,
          shouldUseContrast: brand.code === FLIGHTNETWORK
        })]
      }), /*#__PURE__*/_jsx(Text, {
        children: t(texts.numberOfAvailableOption, numberOfSellableOptions)
      })]
    }), /*#__PURE__*/_jsx(Text, {
      variant: textVariants._16,
      children: discountPercentageTitle
    })]
  });
};
export default EtgFaresHeading;
//# sourceMappingURL=EtgFaresHeading.js.map